"use client"
import React, { useState, useEffect } from "react";
import Image from "react-bootstrap/Image";
import useApi from "@/components/api/useApi";
import Card from "react-bootstrap/Card";

import "@/components/shared/UralityImage.css";

const axios = require("axios");

const UralitySquareImage = ({
  imageId,
  poll,
  size,
  imgClass,
  addClass,
  tag,
  children
}) => {
  const isUrl = url => {
    var expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
    var regex = new RegExp(expression);
    return url.match(regex);
  };

  const [url, setUrl] = useState(null);
  const [px, setPx] = useState(240);
  const [sizeClass, setSizeClass] = useState({
    width: "100%",
    height: "auto"
  });
  const [external, setExternal] = useState(false);

  const api = useApi();

  useEffect(() => {
    if (imageId != null && imageId !== "") {
      if (isUrl(imageId)) {
        setUrl(imageId);
        setExternal(true);
        if (size !== "sm" && size !== "md" && size !== "lg" && size !== "xxl") {
          size = "xl";
        }

        var thePx = 240;

        if (size === "sm") {
          thePx = 40;
        } else if (size === "md") {
          thePx = 80;
        } else if (size === "lg") {
          thePx = 160;
        } else if (size === "xl") {
          thePx = 240;
        } else if (size === "xxl") {
          thePx = 480;
        }

        setPx(thePx);
        setSizeClass({
          maxWidth: thePx,
          maxHeight: thePx,
          width: "auto",
          height: "100%",
          objectFit: "cover"
        });
      } else {
        if (size !== "sm" && size !== "md" && size !== "lg" && size !== "xxl") {
          size = "xl";
        }

        var thePx = 240;

        if (size === "sm") {
          thePx = 40;
        } else if (size === "md") {
          thePx = 80;
        } else if (size === "lg") {
          thePx = 160;
        } else if (size === "xl") {
          thePx = 240;
        } else if (size === "xxl") {
          thePx = 480;
        }

        setPx(thePx);
        setSizeClass({
          width: "100%",
          height: "auto"
        });

        if (poll) {
          pollFn(
            function() {
              return pollForImage(imageId, size);
            },
            10000,
            2000
          )
            .then(url => {
              setUrl(url);
            })
            .catch(error => {});
        } else {
          api.getSquareImage(imageId, size).then(url => {
            setUrl(url);
          });
        }
      }
    }
  }, [imageId]);

  const pollFn = (fn, timeout, interval) => {
    var endTime = Number(new Date()) + (timeout || 6000);
    interval = interval || 2000;

    var checkCondition = function(resolve, reject) {
      fn().then(result => {
        if (result) {
          resolve(result);
        } else if (Number(new Date()) < endTime) {
          setTimeout(checkCondition, interval, resolve, reject);
        }
        // Didn't match and too much time, reject!
        else {
          reject(new Error("timed out for " + fn + ": " + arguments));
        }
      });
    };
    return new Promise(checkCondition);
  };

  const pollForImage = (imageId, size) => {
    return new Promise(function(resolve, reject) {
      api.getSquareImage(imageId, size).then(url => {
        axios
          .get(url)
          .then(() => {
            resolve(url);
          })
          .catch(error => {
            resolve(null);
          });
      });
    });
  };

  let img;

  if (url == null) {
    return <div className="img-missing h-100" />;
  } else {
    if (tag === "Image") {
      img = (
        <Image
          src={"" + url}
          alt={"..."}
          style={sizeClass}
          className={imgClass}
        />
      );
    } else if (tag === "Card.Img") {
      img = (
        <Card.Img
          src={"" + url}
          alt={"..."}
          style={sizeClass}
          className={imgClass}
        />
      );
    } else {
      img = <Image src={"" + url} alt={"..."} className={imgClass} />;
    }
    return (
      <div
        className={`${addClass ?? ""} ${
          external ? "external-square-image" : ""
        }`}
      >
        {img}
        {children}
      </div>
    );
  }
};

export default UralitySquareImage;
